import React from 'react';

import {
	Box,
	Popover,
	PopoverAnchor,
	PopoverContent,
	SearchInput,
} from '@tempo/core';
import {useTranslation} from 'next-i18next';

import useDebounce from '@hooks/useDebounce';
import ArtistResult from '@components/ArtistPickerDrawer/ArtistResult';
import type {ArtistFragment} from '@graphql/generated';

interface ArtistSearchProps {
	onAddArtist: (airtistId: string, artist: ArtistFragment) => void;
}

const ArtistSearch = ({onAddArtist}: ArtistSearchProps) => {
	const [query, setQuery] = React.useState<string>('');
	const [isOpen, setIsOpen] = React.useState(false);
	const [resultWidth, setResultWidth] = React.useState<number | undefined>();
	const {t} = useTranslation();
	const debouncedQuery = useDebounce(query, 300);
	const initialFocusRef = React.useRef<HTMLInputElement>(null);

	const addArtist = (aritstId: string, artist: ArtistFragment) => {
		setQuery('');
		setIsOpen(false);
		onAddArtist(aritstId, artist);
	};

	React.useEffect(() => {
		setIsOpen(query.length > 0);
	}, [query]);

	React.useEffect(() => {
		if (initialFocusRef.current) {
			setResultWidth(initialFocusRef.current.clientWidth);
		}
	}, [query]);

	return (
		<Popover
			isOpen={isOpen}
			isLazy
			initialFocusRef={initialFocusRef as React.RefObject<{focus(): void}>}
		>
			<PopoverAnchor>
				<Box
					mt="spacing.2xl"
					alignSelf="center"
					position="relative"
					px="spacing.l"
					w={['100%', '70%']}
				>
					<SearchInput
						ref={initialFocusRef}
						placeholder={t('Rechercher')}
						onChange={(e) => setQuery(e.target.value)}
						value={query}
					/>
				</Box>
			</PopoverAnchor>
			<PopoverContent
				overflow="scroll"
				overflowX="hidden"
				h="45vh"
				w={resultWidth}
			>
				<ArtistResult query={debouncedQuery} addArtist={addArtist} />
			</PopoverContent>
		</Popover>
	);
};

export default ArtistSearch;
